/**
 * Copyright 2019 CANAL+ Group
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import arrayIncludes from "../../../utils/array_includes";
import MediaCapabilitiesProber from '../mediaCapabilitiesProber/';
/* tslint:disable */
/**
 * A utils class that extends Error object to have custom class errors
 */
var SegmentConstuctionError = /** @class */ (function (_super) {
    __extends(SegmentConstuctionError, _super);
    function SegmentConstuctionError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, SegmentConstuctionError.prototype);
        _this.name = "SegmentConstructionError";
        return _this;
    }
    return SegmentConstuctionError;
}(Error));
export { SegmentConstuctionError };
var ValidationArgsError = /** @class */ (function (_super) {
    __extends(ValidationArgsError, _super);
    function ValidationArgsError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ValidationArgsError.prototype);
        _this.name = "ValidationArgsError";
        return _this;
    }
    return ValidationArgsError;
}(Error));
export { ValidationArgsError };
var RxPlayerError = /** @class */ (function (_super) {
    __extends(RxPlayerError, _super);
    function RxPlayerError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, RxPlayerError.prototype);
        _this.name = "RxPlayerError";
        return _this;
    }
    return RxPlayerError;
}(Error));
export { RxPlayerError };
var IndexDBError = /** @class */ (function (_super) {
    __extends(IndexDBError, _super);
    function IndexDBError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, IndexDBError.prototype);
        _this.name = "IndexDBError";
        return _this;
    }
    return IndexDBError;
}(Error));
export { IndexDBError };
/* tslint:enable */
/**
 * Check the presence and validity of ISettingsDownloader arguments
 *
 * @param ISettingsDownloader - The arguments that the user of the lib provided
 * @returns void
 *
 */
export function checkInitDownloaderOptions(options, db, activeDownloads) {
    return __awaiter(this, void 0, void 0, function () {
        var url, contentID, transport, contentMovie;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof options !== "object" ||
                        Object.keys(options).length < 0) {
                        throw new ValidationArgsError("You must at least specify these arguments: { url, contentID, transport }");
                    }
                    url = options.url, contentID = options.contentID, transport = options.transport;
                    if (url == null || url === "") {
                        throw new ValidationArgsError("You must specify the url of the manifest");
                    }
                    if (contentID == null || contentID === "") {
                        throw new ValidationArgsError("You must specify a contentID of the content you want to download");
                    }
                    if (!arrayIncludes(["smooth", "dash"], transport)) {
                        throw new ValidationArgsError("You must specify a transport protocol, value possible: smooth - dash");
                    }
                    if (activeDownloads[contentID] != null) {
                        throw new ValidationArgsError("The content must be resume instead of starting a new download");
                    }
                    return [4 /*yield*/, db.get("manifests", contentID)];
                case 1:
                    contentMovie = _a.sent();
                    if (contentMovie != null) {
                        throw new ValidationArgsError("An entry with the same contentID is already present, contentID must be unique");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function checkForResumeAPausedMovie(manifest, activeDownloads) {
    if (manifest == null) {
        throw new ValidationArgsError("No content has been found with the given contentID");
    }
    if (activeDownloads[manifest.contentID] != null) {
        throw new ValidationArgsError("The content is already downloading");
    }
    if (manifest.progress.percentage === 100) {
        throw new ValidationArgsError("You can't resume a content that is already fully downloaded");
    }
}
export function checkForPauseAMovie(contentID) {
    if (contentID == null || contentID === "") {
        throw new ValidationArgsError("A valid contentID is mandatory when pausing");
    }
}
// DRM Capabilities:
// Key Systems
var CENC_KEY_SYSTEMS = [
    'com.widevine.alpha',
    'com.microsoft.playready.software',
    'com.apple.fps.1_0',
    'com.chromecast.playready',
    'com.youtube.playready',
];
// Robustness ONLY FOR WIDEVINE
var WIDEVINE_ROBUSTNESSES = [
    'HW_SECURE_ALL',
    'HW_SECURE_DECODE',
    'HW_SECURE_CRYPTO',
    'SW_SECURE_DECODE',
    'SW_SECURE_CRYPTO',
];
/**
 * Construct the necessary configuration for getCompatibleDRMConfigurations() Prober tool
 *
 * @returns {Array.<{type: String, configuration: Object<MediaKeySystemConfiguration>}>}
 */
export function constructConfig() {
    return CENC_KEY_SYSTEMS.map(function (keySystem) { return ({
        type: keySystem,
        configuration: getKeySystemConfigurations(keySystem),
    }); });
}
/**
 * @param {string} keySystem
 * @returns {MediaKeySystemConfiguration[]}
 */
export function getKeySystemConfigurations(keySystem) {
    var videoCapabilities = [];
    var audioCapabilities = [];
    var robustnesses = keySystem === "com.widevine.alpha"
        ? WIDEVINE_ROBUSTNESSES
        : [undefined, undefined, undefined, undefined];
    robustnesses.forEach(function (robustness) {
        videoCapabilities.push({
            contentType: 'video/mp4;codecs="avc1.4d401e"',
            robustness: robustness,
        });
        videoCapabilities.push({
            contentType: 'video/mp4;codecs="avc1.42e01e"',
            robustness: robustness,
        });
        videoCapabilities.push({
            contentType: 'video/webm;codecs="vp8"',
            robustness: robustness,
        });
        audioCapabilities.push({
            contentType: 'audio/mp4;codecs="mp4a.40.2"',
            robustness: robustness,
        });
    });
    return {
        initDataTypes: ['cenc'],
        videoCapabilities: videoCapabilities,
        audioCapabilities: audioCapabilities,
        persistentState: "required",
        sessionTypes: ["persistent-license"]
    };
}
function isFairplayDrmSupported() {
    var MK = window.WebKitMediaKeys;
    var drm = 'com.apple.fps.1_0';
    return MK && MK.isTypeSupported && MK.isTypeSupported(drm, 'video/mp4');
}
export function isSupported() {
    return __awaiter(this, void 0, void 0, function () {
        var drmConfigs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isFairplayDrmSupported()) {
                        // We dont support (HLS/Fairplay) streaming right now :(
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, MediaCapabilitiesProber.getCompatibleDRMConfigurations(constructConfig())];
                case 1:
                    drmConfigs = _a.sent();
                    return [2 /*return*/, drmConfigs.some(function (drmConfig) { return drmConfig.compatibleConfiguration !== undefined; })];
            }
        });
    });
}
